import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteAccount } from '../services/authApi';
import { useApi } from './useApi';

/**
 * アカウント削除のためのカスタムフック
 */
export const useAccountDeletion = () => {
  const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState<boolean>(false);

  // API呼び出しのフックを利用
  const deleteAccountApi = useApi(
    async () => {
      await deleteAccount();
      return true;
    },
    {
      successMessage: 'アカウントを削除しました',
      errorMessage: 'アカウントの削除に失敗しました',
      onSuccess: () => {
        // 削除成功後、ログイン画面へリダイレクト
        setTimeout(() => {
          navigate('/login');
        }, 1000);
      }
    }
  );

  // 削除確認ダイアログを表示
  const confirmDeletion = () => {
    setShowDeleteConfirm(true);
  };

  // 削除確認ダイアログをキャンセル
  const cancelDeletion = () => {
    setShowDeleteConfirm(false);
  };

  // 削除処理を実行
  const handleDeleteAccount = async () => {
    await deleteAccountApi.execute();
  };

  return {
    showDeleteConfirm,
    isDeleting: deleteAccountApi.loading,
    error: deleteAccountApi.error,
    confirmDeletion,
    cancelDeletion,
    handleDeleteAccount,
  };
}; 